import { Navigate } from 'react-router-dom';
import { useFeatureFlagsReady } from '@/hooks/use-feature-flags-ready';
import { useHomeRoute } from '@/hooks/use-home-route';
import { useMcpTesterVisible } from '@/hooks/use-mcp-tester-visible';
import McpTesterPage from '@/pages/mcp-tester-page';
import { PageLoader } from './page-loader';

export function McpTesterRoute() {
  const isReady = useFeatureFlagsReady();
  const showMcpTester = useMcpTesterVisible();
  const homeRoute = useHomeRoute();

  if (!isReady) {
    return <PageLoader />;
  }

  if (!showMcpTester) {
    return <Navigate to={`..${homeRoute}`} replace />;
  }

  return <McpTesterPage />;
}
